<div class="container py-3">
  <div class="card">
    <div class="card-body p-5">
      @for (logItem of items(); track logItem.eventId; let first = $first) {
        @if (cast(logItem); as item) {
          <div class="row mb-3">
            <div class="col-auto text-end" [style.width.px]="150">
              @if (splitTimeAndDate(item.timestamp | calendar); as timestampFormatted) {
                <span class="d-block">{{ timestampFormatted[0] }}</span>
                <span class="d-block">{{ timestampFormatted[1] }}</span>
              }
            </div>
            <div class="d-flex col-auto">
              <div class="d-flex align-items-center border border-info rounded-circle justify-content-center"
                   style="width: 1.5rem; height: 1.5rem;" [ngClass]="first ? 'border-2' : ''">
                @if (first) {
                  <div class="d-flex bg-info rounded-circle" style="width: 0.9rem; height: 0.9rem;">
                  </div>
                }
              </div>
            </div>
            <div class="col">
              <span class="h2 m-0 d-block angular-with-newlines">{{ item.description }}</span>
              <span class="d-block text-secondary mb-1">{{ formatUser(item) }}</span>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
